module.exports = __webpack_public_path__ + "img/green_086.d05f6919.png";